import React from "react";
import Skeleton from "react-loading-skeleton";

export const FilterBarSkeleton = () => {
  return (
    <>
      { [125, 150, 85, 85, 125, 85, 150].map((x, i) => <Skeleton key={`filter-skeleton-${i}`} width={x} height="36" borderRadius="8" />) }
    </>
  );
};
